import React from "react";
import MyTheme from "../../Theme/Theme";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import BoutonText from "../Bouton/BoutonText";
import {connect} from "react-redux";
import LienPicto from "../Picto/LienPicto";


class Link extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isDark: false,
            theme : MyTheme.light,
        }
        this._navigateToWebview = this._navigateToWebview.bind(this);
    }

    _navigateToWebview(){
      const url = this.props.url;
      this.props.refNavigation.navigate('WebView', {url});
    }

    render() {
        const styles = StyleSheet.create({
            ...this.props.style,
            container: {
                justifyContent:"center",
                marginVertical:10
            },
            containerParent  : {
                borderRadius : 10,
                borderWidth : 1,
                paddingVertical : 10,
                borderColor : this.props.theme.colors.tertiary.black10.value,
                fontFamily:this.props.theme.fonts.text,
                justifyContent:"center",
                //width:"100%"
            },
            textParent : {
                fontSize: 14
            },
            source :{
                fontFamily:this.props.theme.fonts.text,
                color : this.props.theme.colors.tertiary.black1.value,
                fontSize: 14
            }
        });
        return (
            <TouchableOpacity style={{flex:1}} onPress={this._navigateToWebview}>
            <View style={{flexDirection:"row"}}>
                <View><LienPicto style={{width:13,height:13,marginTop:2,marginRight:2}} isBouton={true}/></View>
                {this.props.source && <Text style={styles.source}>Source : </Text>}
                <View style={{flexDirection:"row"}}>
                    <Text style={[this.props.style.parentText]}>{this.props.label}</Text>
                </View>
            </View>
            </TouchableOpacity>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(Link);
